"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateUserAttributeFromStringNumber = exports.getDateUserAttribute = void 0;
const millisecondOperations_1 = require("../../util/time/millisecondOperations");
const getDateUserAttribute = (key, label) => ({
    type: 'Date',
    editable: false,
    label,
    name: key,
    displayFn: (actualValue) => (actualValue ? (0, millisecondOperations_1.toDatePickerFormat)(actualValue) : undefined),
    valueFn: (newValue) => (newValue ? new Date(newValue).valueOf() : undefined),
});
exports.getDateUserAttribute = getDateUserAttribute;
const getDateUserAttributeFromStringNumber = (key, label) => ({
    type: 'Date',
    editable: false,
    label,
    name: key,
    displayFn: (actualValue) => (actualValue ? (0, millisecondOperations_1.toDatePickerFormat)(parseInt(actualValue)) : undefined),
    valueFn: (newValue) => (newValue ? new Date(newValue).valueOf().toString() : undefined),
});
exports.getDateUserAttributeFromStringNumber = getDateUserAttributeFromStringNumber;
